module.exports = __webpack_public_path__ + "img/default-coconut.1c70dc35.svg";